import Analytics from 'APP/Services/Analytics'
import { navigation } from 'APP/Nav/NestedNavHelper'

// This is a temporary type for the microAppProps as plan to deprecate it
interface SelfNavigationProps {
  microAppProps?: {
    appId?: string
    post?: {
      props?: {
        microapp?: {
          searchterm?: string
        }
      }
    }
    [key: string]: unknown
  }
  title?: string
  [key: string]: unknown
}

/**
 * Handles navigation for microApp functionality, routing to either the new self-navigation
 * screen or legacy microApp based on feature flag
 *
 * Note: microApp navigation is deprecated and will be removed in future versions
 *
 * @param useSelfNavigationScreen - Feature flag determining if requested screen is SelfNavigation
 * @param props - Navigation props containing microApp data and configuration
 * @param legacyAnalyticsCallback - Optional callback for legacy microApp analytics (deprecated)
 * @param microAppRouteName - Optional route name for microApp navigation (default: 'microApp')
 */
export const handleMicroAppNavigation = (
  useSelfNavigationScreen: boolean,
  props: SelfNavigationProps,
  legacyAnalyticsCallback?: () => void,
  microAppRouteName = 'microApp'
): void => {
  if (!useSelfNavigationScreen) {
    navigation.navigate(microAppRouteName, props)
    legacyAnalyticsCallback?.()
    return
  }

  const searchTerm = props?.microAppProps?.post?.props?.microapp?.searchterm
  navigation.navigate('selfNavigation', {
    specialtyKey: searchTerm,
  })

  Analytics.trackEvent('button_click', {
    button_value: 'Open Self-Navigation Screen',
  })
}
